export default {
  rangeMinLabel: {
    id: 'finder_size_range_min_label',
    defaultMessage: 'Min',
  },
  rangeMaxLabel: {
    id: 'finder_size_range_max_label',
    defaultMessage: 'Max',
  },
} as const
